export default {
  titles: {
    title: 'Supports administrator',
    pending: 'Pending supports',
    received: 'Received supports',
  },
  filters: {
    search: 'Search by charge name or reference ID',
    relation: 'Relation level'
  },
  grid: {
    supportFileCode: 'Support',
    fileName: 'File name',
    supportName: 'Support name',
    accountRelation: 'Account',
    chargeRelation: 'Charge Description',
    accountLevelDocument: 'Charge not related',
    nonPatientFound: 'Information not available',
    patient: 'Patient name',
    relation: 'Relation level',
    referenceId: 'Reference ID',
    upload: 'Upload',
    actions: 'Actions',
    uploadedFile: 'Uploaded file',
    required: 'Required',
    AiAnalysis: 'AI Analysis',
  },
  AiAnalysis: {
    tooltipHeader: `AI analyzes the document and checks if the data is correct and makes sense. 
    The status indicates the result and the confidence level of this reading.`,
    tooltipApproved: 'All right! No discrepancies identified.',
    tooltipRejected: 'Discrepancies identified. Click to see details.',
    tooltipPending: 'AI analysis is pending. please wait a moment.',
    noAiAnalysis: 'No AI analysis available',
    aiStatus: {
      approved: 'Approved',
      rejected: 'Rejected',
      pending: 'Pending'
    }
  },
  relations: {
    account: 'Account',
    charge: 'Charge',
    event: 'Event',
    authorization: 'Authorization'
  },
  labels: {
    charge: 'Charge',
    dragAndDrop: 'Drag and drop the file here',
    uploadFile: 'Upload file'
  },
  actions: {
    upload: 'Upload Support',
    replace: 'Replace Support',
    changeFile: 'Change file',
    uploadInformation: 'Support file information',
    accept: 'Accept',
    cancel: 'Cancel',
    downloadSelected: 'Download selected'
  },
  required: {
    yes: 'YES',
    no: 'NO'
  },
  errors: {
    downloadSelectedError: 'Error downloading selected files',
  },
}
